import { render, staticRenderFns } from "./CASAProduct.vue?vue&type=template&id=5e788851&"
import script from "./CASAProduct.vue?vue&type=script&lang=js&"
export * from "./CASAProduct.vue?vue&type=script&lang=js&"
import style0 from "./CASAProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports